import { Button } from '@mui/material';

export interface ButtonActionListT {
  name: string;
  fn: Function;
  icon?: any;
}
interface ButtonActionListProps {
  list: Array<ButtonActionListT> | undefined;
}
function ButtonActionList({ list }: ButtonActionListProps) {
  return (
    <>
      {
        list?.map((action) => (
          <Button
            key={action.name}
            variant="outlined"
            color="info"
            size="small"
            startIcon={action.icon}
            onClick={() => action.fn()}
          >
            {action.name}
          </Button>
        ))
      }
    </>
  );
}

export default ButtonActionList;
